module.exports = __webpack_public_path__ + "img/google-podcasts-logo.855ba8a7.png";